import { ISortState } from '../../interfaces/ISortState';

/**
 * Determines the next sort state based on the current sort state and the field to be sorted.
 *
 * @param {Object} params - The parameters object
 * @param {ISortState} params.currentSortState - The current sort state containing field and order
 * @param {string} params.fieldToBeSorted - The field name that should be sorted
 * @returns {ISortState} The next sort state
 *
 * @description
 * The function implements the following logic:
 * - If fieldToBeSorted is empty, returns default state (empty field, ASC order)
 * - If same field is clicked:
 *   - If current order is DESC, clears sorting
 *   - Otherwise toggles between ASC and DESC
 * - If different field is clicked, sorts that field in ASC order
 */
export function getNextSortState({
  currentSortState,
  fieldToBeSorted,
}: {
  currentSortState: ISortState;
  fieldToBeSorted: string;
}): ISortState {
  if (fieldToBeSorted === '') {
    return {
      field: '',
      order: 'ASC',
    };
  }
  if (currentSortState.field === fieldToBeSorted) {
    if (currentSortState.order === 'DESC') {
      return {
        field: '',
        order: 'ASC',
      };
    }
    return {
      field: fieldToBeSorted,
      order: currentSortState.order === 'ASC' ? 'DESC' : 'ASC',
    };
  }
  return {
    field: fieldToBeSorted,
    order: 'ASC',
  };
}
